<template>
  <v-container>
    <h1>404</h1>
    <h2>Page Not Found</h2>
    <p>We could not find the page you are looking for.</p>
  </v-container>
</template>

<script>
export default {
  name: "page-not-found.vue",
};
</script>

<style scoped>
* {
  text-align: center;
}
h1,
h2 {
  line-height: 1;
}
h1 {
  font-size: 6em;
}
h2 {
  font-size: 2em;
}
p {
  margin-top: 20px;
}
</style>
